import React from "react";
import moment from "moment-timezone";

import { errorRed, tintRed } from "../../design-system/colors";
import MoovsBanner from "../globals/MoovsBanner";
import { useTimeFormat } from "globals/hooks";

type TripCancelledBannerProps = {
  cancelledAt: Date;
};

function TripCancelledBanner(props: TripCancelledBannerProps) {
  const { cancelledAt } = props;
  const { formatTime, formatDate } = useTimeFormat();

  // derived state
  const formattedDate = `${formatDate(moment(cancelledAt), true)}, ${formatTime(moment(cancelledAt))}`;

  return (
    <MoovsBanner
      bannerText={`The trip was cancelled on ${formattedDate}`}
      bannerBgColor={tintRed}
      bannerTextColor={errorRed}
    />
  );
}

export default TripCancelledBanner;
